// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-card {
  border-radius: 16px;
  cursor: pointer;
}
.help-card:hover .card-image {
  transform: scale(1.05);
}

.card-image-container {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: linear-gradient(135deg, var(--ion-color-light) 0%, var(--ion-color-light-shade) 100%);
}

.card-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}

.card-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent);
  opacity: 0.6;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.pinned-icon {
  font-size: 1.5rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  zoom: 1.5;
}

.custom-card-header {
  background: linear-gradient(90deg, var(--ion-color-primary), var(--ion-color-secondary));
  border-radius: 12px 12px 0 0;
  margin-bottom: 0.5em;
}

.custom-card-title {
  letter-spacing: 0.5px;
  text-align: center;
  text-transform: uppercase;
}

.custom-card-content {
  padding: 1.2em 1em 1em 1em;
}

.description-ellipsis {
  text-align: center;
  max-height: 3.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s;
}

.description-ellipsis:hover {
  background: rgba(0, 0, 0, 0.04);
}

.card-footer {
  display: flex;
  justify-content: center;
  padding: 0.7em;
}

.card-footer ion-button {
  text-overflow: ellipsis;
  --background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}

.card-footer-empty {
  height: 2.5em;
}

@media only screen and (max-width: 720px) {
  ion-card {
    zoom: 0.8 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/pages/user-help-page/user-help-page.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EAEA,eAAA;AADF;AASI;EACE,sBAAA;AAPN;;AAaA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iGAAA;AAVF;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAXF;;AAcA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,oEAAA;EACA,YAAA;EACA,6BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,SAAA;AAXF;;AAcA;EACE,wFAAA;EACA,4BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;AAXF;;AAcA;EACE,0BAAA;AAXF;;AAcA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AAXF;;AAcA;EACE,+BAAA;AAXF;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AAXF;;AAcA;EACE,uBAAA;EACA,sCAAA;EACA,wCAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAaA;EACI;IACE,oBAAA;EAVJ;AACF","sourcesContent":["// Enhanced Help Card Styling\n.help-card {\n  border-radius: 16px;\n\n  cursor: pointer;\n\n\n  &:hover {\n    // transform: translateY(-6px);\n    // box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n    // border-color: var(--ion-color-primary-tint);\n\n    .card-image {\n      transform: scale(1.05);\n    }\n  }\n}\n\n// Enhanced Image Container\n.card-image-container {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--ion-color-light) 0%, var(--ion-color-light-shade) 100%);\n}\n\n\n.card-overlay {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 2;\n}\n\n.card-gradient {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent);\n  opacity: 0.6;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.pinned-icon {\n  font-size: 1.5rem;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  padding: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  zoom: 1.5;\n}\n\n.custom-card-header {\n  background: linear-gradient(90deg, var(--ion-color-primary), var(--ion-color-secondary));\n  border-radius: 12px 12px 0 0;\n  margin-bottom: 0.5em;\n}\n\n.custom-card-title {\n  letter-spacing: 0.5px;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.custom-card-content {\n  padding: 1.2em 1em 1em 1em;\n}\n\n.description-ellipsis {\n  text-align: center;\n  max-height: 3.6em; // About 2 lines\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.description-ellipsis:hover {\n  background: rgba(0,0,0,0.04);\n}\n\n.card-footer {\n  display: flex;\n  justify-content:center;\n  padding: 0.7em;\n}\n\n.card-footer ion-button {\n  text-overflow: ellipsis;\n  --background: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast);\n}\n\n.card-footer-empty {\n  height: 2.5em;\n}\n@media only screen and (max-width: 720px) {\n    ion-card {\n      zoom: 0.8 !important;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
